import Category from '@/models/Category';
import { Family } from '@/models/Family';
import * as Yup from 'yup';

export const schema = Yup.object().shape({
    name: Yup.string()
        .required()
        .min(1),
    author: Yup.string()
        .required()
        .min(1),
    // locale: Yup.string().required().min(2),
    mainImage: Yup.string()
        .required()
        .min(1),
    tags: Yup.array().required(),
    categories: Yup.array().required(),
});

export const formInitialState = {
    name: '',
    author: '',
    description: '',
    locale: '',
    mainImage: '',
    category: {} as Category,
    category2: {} as Category,
    tags: [],
    families: [] as Family[],
};

export const formErrors = {
    nameError: false,
    authorError: false,
    localeError: false,
    mainImageError: false,
    categoriesError: false,
    tagsError: false,
};
